import loadScript from 'unified-navigation-ui/utils/loadScript';
import loadCriticalCSS from 'unified-navigation-ui/utils/loadCriticalCSS';
// @ts-expect-error legacy-hubspot-bender-context is a virtual, undeclared module
import { bender } from 'legacy-hubspot-bender-context';
loadScript(`${bender.staticDomainPrefix}${bender.depPathPrefixes[bender.project]}/bundles/project-hubless.js`);
loadCriticalCSS({
  isHubless: true
});